import { axiosGet, axiosPost } from "../../../../react_axios/Axios";
import { headers, getRentalAudioVideoMasterListUrl, insertUpdateRentalAudioVideoMasterUrl, deleteRentalAudioVideoMasterUrl, GET_RENTAL_AUDIO_VIDEO_MASTER_LIST, INSERT_UPDATE_RENTAL_AUDIO_VIDEO_MASTER, DELETE_RENTAL_AUDIO_VIDEO_MASTER, getAgencyRentalAvEquipmentListUrl, insertUpdateAgencyRentalAvEquipmentUrl, deleteAgencyRentalAvEquipmentUrl, GET_AGENCY_RENTAL_AV_EQUIPMENT_LIST, INSERT_UPDATE_AGENCY_RENTAL_AV_EQUIPMENT, DELETE_AGENCY_RENTAL_AV_EQUIPMENT, getMstRentalAvEquipmentListUrl, insertUpdateMstRentalAvEquipmentUrl, deleteMstRentalAvEquipmentUrl, GET_MST_RENTAL_AV_EQUIPMENT_LIST, INSERT_UPDATE_MST_RENTAL_AV_EQUIPMENT, DELETE_MST_RENTAL_AV_EQUIPMENT } from "../../../../utils/constants";


export const insertUpdateRentalAudioVideoMaster_action = (RentalAudioVideoMasterList) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            RentalAudioVideoMasterList: RentalAudioVideoMasterList
        }
        console.log("getVisaInvitation_action Action------->", params)

        const res = await axiosPost(insertUpdateRentalAudioVideoMasterUrl, params, headers)

        dispatch({
            type: INSERT_UPDATE_RENTAL_AUDIO_VIDEO_MASTER,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getRentalAudioVideoMasterList_action = () => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
        }
        console.log("getVisaInvitation_action Action------->", params)

        const res = await axiosGet(getRentalAudioVideoMasterListUrl, params, headers)

        dispatch({
            type: GET_RENTAL_AUDIO_VIDEO_MASTER_LIST,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const deleteRentalAudioVideoMaster_action = (deleteId) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            AgencyRentalAudioVideoID: deleteId
        }
        console.log("deleteExhibitionDocument_action Action------->", params)

        const res = await axiosGet(deleteRentalAudioVideoMasterUrl, params, headers)

        dispatch({
            type: DELETE_RENTAL_AUDIO_VIDEO_MASTER,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getAgencyRentalAvEquipmentList_action = () => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
        }
        const res = await axiosGet(getAgencyRentalAvEquipmentListUrl, params, headers)
        dispatch({ type: GET_AGENCY_RENTAL_AV_EQUIPMENT_LIST, payload: res });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const insertUpdateAgencyRentalAvEquipment_action = (data) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            ...data
        }
        const res = await axiosPost(insertUpdateAgencyRentalAvEquipmentUrl, params, headers)
        dispatch({ type: INSERT_UPDATE_AGENCY_RENTAL_AV_EQUIPMENT, payload: res });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const deleteAgencyRentalAvEquipment_action = (id) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            AgencyRentalAvEquipmentID: id
        }
        const res = await axiosGet(deleteAgencyRentalAvEquipmentUrl, params, headers)
        dispatch({ type: DELETE_AGENCY_RENTAL_AV_EQUIPMENT, payload: res });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getMstRentalAvEquipmentList_action = () => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
        }
        const res = await axiosGet(getMstRentalAvEquipmentListUrl, params, headers)
        dispatch({ type: GET_MST_RENTAL_AV_EQUIPMENT_LIST, payload: res });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const insertUpdateMstRentalAvEquipment_action = (RentalAvEquipmentList) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            RentalAvEquipmentList,
        }
        const res = await axiosPost(insertUpdateMstRentalAvEquipmentUrl, params, headers)
        dispatch({ type: INSERT_UPDATE_MST_RENTAL_AV_EQUIPMENT, payload: res });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const deleteMstRentalAvEquipment_action = (id) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            RentalAvEquipmentID: id,
        }
        const res = await axiosGet(deleteMstRentalAvEquipmentUrl, params, headers)
        dispatch({ type: DELETE_MST_RENTAL_AV_EQUIPMENT, payload: res });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}